var $ = require('jquery');
import UserAgentJS from 'useragent.js';

"use strict";

var	DEFAULTS = {
};

var CurtainScrollHandler = function (selector, options ) {
	this.$t = $(selector);
	this.curtainInstance = this.$t.data('curtainInstance');
	this.$tPlaceholder = $('.curtain-placeholder');
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.$t.data('curtainScrollHandlerApplied', '1');
	this.initialise_();
};

CurtainScrollHandler.prototype.initialise_ = function() {
	this.lastScroll = (window.pageYOffset || document.documentElement.scrollTop);
	this.timeout = null;
	if (this.$t.size() > 0) {
		this.bindScrollEvent_();
	}

};

CurtainScrollHandler.prototype.bindScrollEvent_ = function() {
	var self_ = this;
	$(window).off('scroll.curtainScrollHandler').on('scroll.curtainScrollHandler', function(event) {
		var scrollTop = (window.pageYOffset || document.documentElement.scrollTop);
		var actualZoom = (window.outerWidth / window.document.documentElement.clientWidth).toFixed(1);
		var browser = UserAgentJS.analyze(navigator.userAgent).browser.image;
		/*if (
			self_.lastScroll < 1 && !window._isTouchDevice() && (
				!(browser == 'safari' || browser == 'chrome') ||
				((browser == 'safari' || browser == 'chrome') && actualZoom == 1.0)
			)
		) {
			$('html, body').animate({ scrollTop: 1 }, 0);
			event.preventDefault(); // hide curtain on first scroll
		}*/
		clearTimeout(self_.timeout);
		self_.timeout = window.setTimeout(function() {
			if (scrollTop >= 1) {
				self_.$t.slideUp(200);
				self_.$tPlaceholder.slideUp(200, function() {
					$('body').trigger('CURTAIN_HIDDEN_SCROLLTO_SUCCESS');
				});
				$('.js_curtain-handler').blur().removeClass('active'); // fuj
				self_.curtainInstance.forceResetHandlersState();
			} else {
				if (!window.projectConfig.authorInfoDisabled) {
					self_.$t.slideDown(200);
					self_.$tPlaceholder.slideDown(200);
				}
			}

			self_.lastScroll = scrollTop;
		}, 300	);
	});
};

module.exports = CurtainScrollHandler;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/CurtainScrollHandler.js